export default __webpack_public_path__ + "static/media/alert-long-new.074fc630.wav";